async function groupProductMissing(cart) {
    const tmp_group = {};
    if (cart.items && cart.items.length) {
        cart.items.forEach(item => {
            const group_name = item.properties && item.properties['_groupId'] !== undefined && item.properties['_groupId'] !== '' ? item.properties['_groupId'] : null;
            if (group_name != null) {
	            tmp_group[group_name] = tmp_group[group_name] || [];
    	        tmp_group[group_name].push(item);
            }
        });
    }
    return !Object.keys(tmp_group).some(grp_key => tmp_group[grp_key]?.length < 2);
};

async function checkProductStock(form_btn_elem) {
    await jQuery.getJSON('/cart.js', async function (cart) {
        let isGroupProductMissing = await groupProductMissing(cart) || false;
        if(!isGroupProductMissing){
            alert("To proceed with placing an order, it's necessary to have both a Ring and Stone product from the Store.");
            return;
        }

        let variant_ids = cart.items.map(e => e.id);
        var formData = new FormData();
        formData.append("action", "checkVDBProductStock");
        formData.append("shop", Shopify.shop);
        formData.append("variant_ids", variant_ids.join(','));

        await fetch(`/apps/goodstone-diamond-search/frontend.php`, {
            method: 'POST',
            body: formData
        }).then(response => response.text())
        .then(result => {
            let obj = JSON.parse(result);
            if (obj.SUCCESS == 'TRUE') {
                var all_available = 'Yes';
                var err_msg = '';
                for (var i = 0; i < obj.DATA.length; i++) {
                    if (obj.DATA[i].available == 'No') {
                        all_available = 'No';
                        err_msg += 'Product ' + obj.DATA[i].vdb_item_title + ' is out of stock.\n';
                    }
                }

                if (all_available == 'Yes') {
                    var nearestButton = findNearestButtonB(form_btn_elem);
                    if (nearestButton && nearestButton.getAttribute('type') === 'submit') {
                        nearestButton.click();
                    }
                } else {
                    alert(err_msg);
                }
            } else {
                var nearestButton = findNearestButtonB(form_btn_elem);
                if (nearestButton && nearestButton.getAttribute('type') === 'submit') {
                    nearestButton.click();
                }
            }
        }).catch(error => console.log('error', error));
    });
};

function findNearestButtonB(element) {
    var parent = element.parentNode;
    var childElements = parent.children;
    for (var i = 0; i < childElements.length; i++) {
        var child = childElements[i];
        if (child.tagName === 'BUTTON' && child.getAttribute('type') === 'submit') {
            return child;
        }
    }
    return null;
};